import React from 'react';
import PropTypes from 'prop-types';
// core components
import GridItem from 'components/UI/Grid/GridItem';
import GridContainer from 'components/UI/Grid/GridContainer';
// our components
import RadarListUpdate from 'components/Radar/Update';

const ScreenRadarUpdate = ({ match, routePaths, target }) => (
  <GridContainer justify="center">
    <GridItem xs={12} sm={6}>
      <RadarListUpdate
        id={match.params.id}
        routePaths={routePaths}
        target={target}
      />
    </GridItem>
  </GridContainer>
);

ScreenRadarUpdate.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  routePaths: PropTypes.shape({}),
  target: PropTypes.string,
};

ScreenRadarUpdate.defaultProps = {
  routePaths: undefined,
  target: undefined,
};

export default ScreenRadarUpdate;
